<template>
    <div class="container-comparative-data">
        <span class="text-comparative-data">Dados comparativos com a data </span>
        <span class="text-date">{{ !!dynamicFilters.comparativeDate.finalDate ? dynamicFilters.comparativeDate.initialDate + ' á ' + dynamicFilters.comparativeDate.finalDate : dynamicFilters.comparativeDate.initialDate }} - </span>
        <span class="text-actions" @click="dataCalendar = !dataCalendar">Alterar</span>
        <div v-if="dataCalendar" class="comparative-data-calendar">
            <ui-datepicker
                group-reverse
                is-range
                :min-date="false"
                :onClickGroupReverse="onChangeAlter"
                :max-date="maxDate"
                @input="handleInputValues"
                />
        </div>
    </div>
</template>

<script>
	import { uiDatepicker } from '@/components/ui/form'
    import { mapState, mapMutations } from 'vuex'
    import moment from 'moment';

    export default {
        name: 'comparative-data',

        components: {
            uiDatepicker
        },

        data() {
            return {
                dataCalendar: false,
                daysValue: {
                    start: '',
                    end: ''
                },
                maxDate: new Date()
            }
        },

        computed: {
            ...mapState('dashboardFilter', ['dynamicFilters'])
        },

        methods: {
            ...mapMutations('dashboardFilter', ['UPDATE_COMPARATIVE_DATA']),

            handleInputValues(value) {

                if (value.start) {
                    this.daysValue.start = this.formatDate(value.start);
                } else {
                    this.daysValue.start = '';
                }
                if (value.end) {
                    this.daysValue.end = this.formatDate(value.end);
                } else {
                    this.daysValue.end = '';
                }
            },
            formatDate(date) {
                return moment(date).format('DD/MM/YYYY');
            },

            applyFilters() {
                this.$store.dispatch('dashboardFilter/applyFilters')
            },

            handleInputValuesGlobal() {
                const { initialDate, finalDate } = this.dynamicFilters.comparativeDate
                const { start, end } = this.daysValue

                if(initialDate !== this.daysValue.start || 
                (!!end && finalDate !== end)) {
                    this.UPDATE_COMPARATIVE_DATA({
                        initialDate: this.daysValue.start,
                        finalDate: this.daysValue.end
                    })
                } 
                if(start === '' || end === '') {
                    this.UPDATE_COMPARATIVE_DATA({
                        initialDate: '',
                        finalDate: ''
                    })
                }

                this.applyFilters()
            },

            onChangeAlter() {
                this.handleInputValuesGlobal()

                this.dataCalendar = !this.dataCalendar
            }
        }
    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>